/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./chatMessage.vue?vue&type=template&id=30f0b692&scoped=true&"
import script from "./chatMessage.vue?vue&type=script&lang=js&"
export * from "./chatMessage.vue?vue&type=script&lang=js&"
import style0 from "./chatMessage.vue?vue&type=style&index=0&id=30f0b692&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f0b692",
  null
  
)

export default component.exports